import { render } from "./FolderContents.vue.js?vue&type=template&id=2aa9576e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderContents.vue?vue&type=template&id=2aa9576e"
import script from "./FolderContents.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderContents.vue?vue&type=script&lang=js"
export * from "./FolderContents.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/FolderContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aa9576e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aa9576e', __exports__)) {
    api.reload('2aa9576e', __exports__)
  }
  
  module.hot.accept("./FolderContents.vue.js?vue&type=template&id=2aa9576e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderContents.vue?vue&type=template&id=2aa9576e", () => {
    api.rerender('2aa9576e', render)
  })

}


export default __exports__